export default __webpack_public_path__ + "static/media/yakan_icon.d2842b45.png";